import * as OM from '@/model';
import * as CONST from '@/const';
import { StorageServices } from '@/services/StorageServices';
import { RouteLocationNormalizedLoadedGeneric } from 'vue-router';
import { createStore, StoreOptions } from 'vuex';
import { CommessaClient, LoginClient, ProgramSubscriptionClient } from '@/services/Services';
import { CommonServices } from '@/services/CommonServices';
import { ModalServices } from '@/services/ModalServices';
import router, { getMenuByRole } from '@/router';

let storeState = {
    showSpinner: <number>0,
    user: <OM.User>null,
    routeBuster: Date.now(),
    subscription: <OM.ProgramSubscriptionDetailVm>null,
    backButtonFunction: <() => void>null,
    isSubscriptionActive: () => {
        if(!store.state.commesse.selectedCommessa)
            return true;
        
        return store.state.commesse.selectedCommessa && store.state.commesse.selectedCommessa.isSubscriptionActive;
        // if(!store.state.subscription) return false;
        // if(!store.state.subscription.endsOn) return true;
        // return new Date(store.state.subscription.endsOn).getTime() > Date.now();
    },
    updateSubscription: () => {
        return ProgramSubscriptionClient.getActiveOrLastForUser(store.state.user.identifier)
        .then(x => {
            store.state.subscription = x;
        })
    },
    commesse: {
        selectCommessa: (commessa: OM.CommessaSummaryVm, fromLayout: boolean = false) => {
            return new Promise<void>((resolve, reject) => {
                if(fromLayout){
                    ModalServices.confirmModal("Attenzione", "Cambiando commessa tutto il lavoro non salvato andrà perso. Proseguire?",
                        "CONFERMO",
                        "ANNULLA",
                    () => {
                        successCb()
                        .then(() => {
                            store.state.routeBuster = Date.now();
                            let menu = getMenuByRole(store.state.user.role)
                            if(menu.commessaPaths[0]){
                                router.push(menu.commessaPaths[0].path);
                            } else {
                                router.push(menu.systemPaths[0].path);
                            }
                            resolve();
                        })
                        .catch(() => reject())
                    })
                } else {
                    successCb()
                    .then(() => resolve())
                    .catch(() => reject())
                }
            })

            function successCb(){
                return new Promise<void>((resolve, reject) => {
                    LoginClient.selectCommessa(commessa.identifier)
                    .then(newToken => {
                        CommonServices.setAuthToken(newToken);
                        StorageServices.setSelectedCommessa(commessa.identifier);
                        return CommessaClient.getRoleInCommessa(store.state.user.identifier, commessa.identifier);
                    })
                    .then(role => {
                        store.state.commesse.roleInCommessa = role;
                        store.state.commesse.selectedCommessa = commessa;
                        resolve();
                    })
                    .catch(err => reject(err))
                })
            }
        },
        selectedCommessa: <OM.CommessaSummaryVm>null,
        roleInCommessa: <string>'',
        ownedCommessas: <OM.CommessaSummaryVm[]>[],
        invitedCommessas: <OM.CommessaSummaryVm[]>[]
    },
    isCommessaAdmin: () => {
        return store.state.commesse.roleInCommessa == CONST.CommessaRoles.Admin;
    },
    isCommessaEditor: () => {
        return store.state.commesse.roleInCommessa == CONST.CommessaRoles.Admin || store.state.commesse.roleInCommessa == CONST.CommessaRoles.Editor;
    },
    isCommessaViewer: () => {
        return store.state.commesse.roleInCommessa == CONST.CommessaRoles.Admin || store.state.commesse.roleInCommessa == CONST.CommessaRoles.Editor || store.state.commesse.roleInCommessa == CONST.CommessaRoles.Viewer;
    },
    isMobile: false,
    isCordova: false,
    isIos: false,
    // assunto true finché NetworkServices non determina lo stato reale (vedi onDeviceReady/onResume)
    isOnline: true,
    openBrowser: ($event) => {
        let findParentWithHref = (element) => {
            if (element.href) {
                return element.href;
            } else if (element.parentElement) {
                return findParentWithHref(element.parentElement);
            }
            return null;
        };
        
        let url;
        if ($event.target) {
            $event.preventDefault();
            url = findParentWithHref($event.target);
        } else {
            url = $event;
        }
        
        if (url) {
            if (!window.cordova) {
                window.open(url, "_blank");
            } else {
                window.cordova.InAppBrowser.open(url, "_system");
            }
        } else {
            console.error("Nessun URL trovato nell'elemento o nei suoi parent.");
        }
    },
    isImpersonating: () => {
        return !!StorageServices.getSuperAdminToken();
    },
    isSuperAdmin: () => {
        if(!store.state.user) return false;
        return store.state.user.role == CONST.AppRoles.SuperAdmin;
    },
    isUser: () => {
        if(!store.state.user) return false;
        return store.state.user.role == CONST.AppRoles.SuperAdmin || store.state.user.role == CONST.AppRoles.User;
    },
    getUserDisplayName: () => {
        const user = store.state.user;
        if(!user) return '';
        const p = user.personalData;
        if(p?.name && p?.surname) return `${p.name} ${p.surname}`;
        return user.authData?.username ?? '';
    },
    beforeNavCbs: <((to: RouteLocationNormalizedLoadedGeneric, from: RouteLocationNormalizedLoadedGeneric) => void)[]>[],
    afterNavCbs: <((to: RouteLocationNormalizedLoadedGeneric, from: RouteLocationNormalizedLoadedGeneric) => void)[]>[],
}

storeState.user = StorageServices.getUser();
// storeState.commesse.selectedCommessa = StorageServices.getSelectedCommessa();


let vuestore: StoreOptions<typeof storeState> = {
    state: storeState,
}

let store = createStore(vuestore);

export default store;

function onResizeFunction(){
    if(window.innerWidth < 992){
        store.state.isMobile = true;
    } else {
        store.state.isMobile = false;
    }
}
window.addEventListener('resize', onResizeFunction)
onResizeFunction();

function copyToClipboard(text, clickEv: MouseEvent = null) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);

    if(clickEv){
        var popup = document.createElement("div");
        popup.style.position = "fixed";
        popup.style.left = clickEv.clientX + "px";
        popup.style.top = clickEv.clientY + "px";
        popup.style.backgroundColor = "white";
        popup.style.border = "1px solid grey";
        popup.style.pointerEvents = "none";
        popup.style.touchAction = "none";
        document.body.append(popup);
        setTimeout(() => {
            popup.remove();
        }, 400);
    }
}
